import React, { useState } from "react";
import Datatable from "../../components/datatable/Datatable";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import "./list.css";

const List = ({ columns }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="list1">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={`listContainer1 ${collapsed ? "collapsed" : ""}`}>
        <Navbar />
        <Datatable columns={columns} collapsed={collapsed} />
      </div>
    </div>
  );
};

export default List;
